import { useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useNavigate } from 'react-router-dom';
import { Button, IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

function PdfPreview() {
    const navigate = useNavigate();
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [base64Data, setBase64Data] = useState(null);

    const pdfContentType = 'application/pdf';
    const pdfWrapperRef = useRef(null);

    const base64toBlob = (data) => {
        try {
            const bytes = atob(data);
            let length = bytes.length;
            let out = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                out[i] = bytes.charCodeAt(i);
            }
            return new Blob([out], { type: pdfContentType });
        } catch (error) {
            console.error('Failed to convert base64 to Blob:', error);
            return null;
        }
    };

    const blob = base64toBlob(base64Data || "");
    const url = blob ? URL.createObjectURL(blob) : "";

    useEffect(() => {
        const storedData = localStorage.getItem('tabData');
        if (storedData) {
            setBase64Data(JSON.parse(storedData));
        }
        return () => {
            if (url)
                URL.revokeObjectURL(url)
            localStorage.removeItem('tabData'); // Clean up storage
        }
    }, []);

    if (!url) {
        return <div>Error loading PDF. Please check the base64 string.</div>;
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = 'document.pdf';
        downloadLink.click();
    };

    const getPageWidth = () => {
        if (pdfWrapperRef.current) {
            return pdfWrapperRef.current.offsetWidth;
        }
        return 0;
    };

    const goToPrevPage = () => {
        setPageNumber(prevPage => Math.max(prevPage - 1, 1));
    };

    const goToNextPage = () => {
        setPageNumber(prevPage => Math.min(prevPage + 1, numPages));
    };

    const goToHome = () => {
        navigate("/home");
    };

    return (
        <>
            {url && (
                <div className='pdf-container'>
                    <div className='controls-1'>
                        <Button variant='contained' sx={{ mr: 2 }} className='back' onClick={goToHome}>Back</Button>
                        <Button variant='contained' sx={{ mr: 2 }} className='print-btn' onClick={handlePrint}>Print</Button>
                        <Button variant='contained' className='download-btn' onClick={handleDownload}>Download</Button>
                    </div>
                    <div ref={pdfWrapperRef} className="pdf-wrapper">
                        <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={pageNumber} width={getPageWidth()} />
                        </Document>
                    </div>
                    <div className='controls-2'>
                        <p style={{ margin: "auto 0" }}>
                            Page {pageNumber} of {numPages}
                        </p>
                        <div>
                            <IconButton onClick={goToPrevPage} disabled={pageNumber <= 1}>
                                <ArrowBackIosIcon />
                            </IconButton>
                            <IconButton onClick={goToNextPage} disabled={pageNumber >= numPages}>
                                <ArrowForwardIosIcon />
                            </IconButton>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PdfPreview;
